import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import useSafeState from "./useSafeState";
import useIntersectionObserver from "./useIntersectionObserver";
import { useDebugValue } from "react";
function useIntersecting(target, optoins) {
  var _useSafeState = useSafeState(false),
    _useSafeState2 = _slicedToArray(_useSafeState, 2),
    intersecting = _useSafeState2[0],
    setIntersecting = _useSafeState2[1];
  useIntersectionObserver(target, function (entries) {
    if (entries && entries[0] && entries[0].isIntersecting) {
      setIntersecting(true);
    } else {
      setIntersecting(false);
    }
  }, optoins);
  useDebugValue(intersecting);
  return intersecting;
}
export default useIntersecting;